<template>
  <el-tooltip effect="dark" :content="tooltip" placement="top-start">
    <template #default>
      <el-button
        type="success"
        :disabled="disabled"
        :icon="isDesktop ? 'PlusElementIcon' : ''"
        size="small"
        @click="openModal"
      >
        Create a list
      </el-button>
    </template>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'ListButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: 'Create a new spot list'
    }
  },
  setup(props, context) {
    const { isDesktop } = useResize()

    const openModal = () => {
      context.emit('click')
    }

    return { openModal, isDesktop }
  }
})
</script>
